import { supabase } from './supabaseClient';
import { getNegocioId, setCodigoPais } from './negocioActual';
import { registrarEvento } from './analyticsService';
import { monedaPorPais, zonaHorariaPorPais, codigoTelefonoPorPais } from '../utils/paises';
import { CATEGORIAS_DISTRIBUIDOR } from '../utils/perfil';

// Onboarding: perfil de segmentación del negocio (1 fila por negocio).
// Guarda las respuestas y marca el negocio como "onboarding completado" para
// que el formulario no vuelva a aparecer.

// Guarda/actualiza las respuestas y marca el onboarding como visto.
// `omitido` = true cuando el usuario lo saltó ("completar después").
export async function finalizarOnboarding(respuestas, { omitido = false } = {}) {
  const negocioId = getNegocioId();
  if (!negocioId) throw new Error('SIN_NEGOCIO');
  const { data: sesion } = await supabase.auth.getSession();
  const ahora = new Date().toISOString();

  const fila = {
    negocio_id: negocioId,
    user_id: sesion?.session?.user?.id || null,
    tipo_usuario: respuestas.tipo_usuario || null,
    pais: respuestas.pais || null,
    rubro: respuestas.rubro || null,
    rubro_otro: respuestas.rubro_otro?.trim() || null,
    empleados: respuestas.empleados || null,
    antiguedad: respuestas.antiguedad || null,
    tamano_ventas: respuestas.tamano_ventas || null,
    objetivo_principal: respuestas.objetivo_principal || null,
    objetivo_otro: respuestas.objetivo_otro?.trim() || null,
    necesidades: respuestas.necesidades || [],
    como_conocio: respuestas.como_conocio || null,
    como_conocio_otro: respuestas.como_conocio_otro?.trim() || null,
    completado: !omitido,
    omitido: !!omitido,
    actualizado_en: ahora,
  };

  const { error } = await supabase
    .from('onboarding_respuestas')
    .upsert(fila, { onConflict: 'negocio_id' });
  if (error) throw error;

  // Marca el gate (columna en negocios) para no volver a mostrarlo. Si eligió
  // país, también se guarda en el negocio y se configura solo la MONEDA y la
  // ZONA HORARIA del país (así un negocio de USA arranca en USD y hora de USA
  // sin tener que tocar Configuración). El código de WhatsApp se ajusta al vuelo.
  const cambiosNegocio = { onboarding_completado: ahora };
  if (respuestas.pais && respuestas.pais !== 'Otro') {
    cambiosNegocio.pais = respuestas.pais;
    const moneda = monedaPorPais(respuestas.pais);
    if (moneda) cambiosNegocio.moneda = moneda;
    cambiosNegocio.zona_horaria = zonaHorariaPorPais(respuestas.pais);
    setCodigoPais(codigoTelefonoPorPais(respuestas.pais));
  }
  // El rubro se guarda en el negocio para habilitar funciones por perfil
  // (ej. campos de destino/servicio en clientes para agencias de viajes).
  if (respuestas.rubro) cambiosNegocio.rubro = respuestas.rubro;
  // "¿Qué vendes?" (sql/144): decide qué partes del menú ve.
  if (['productos', 'servicios', 'ambos'].includes(respuestas.vende)) cambiosNegocio.vende = respuestas.vende;
  const { error: err2 } = await supabase
    .from('negocios')
    .update(cambiosNegocio)
    .eq('id', negocioId);
  if (err2) throw err2;

  // Perfil Distribuidor: arranca con sus categorías (si aún no tiene ninguna).
  if (respuestas.rubro === 'distribuidor' && !omitido) {
    try { await sembrarCategoriasDistribuidor(negocioId); } catch (e) { /* no bloquea la entrada */ }
  }

  // Evento de uso (best-effort).
  registrarEvento(omitido ? 'onboarding_omitido' : 'onboarding_completado', {
    tipo_usuario: fila.tipo_usuario,
    rubro: fila.rubro,
    objetivo_principal: fila.objetivo_principal,
  });

  return ahora;
}

async function sembrarCategoriasDistribuidor(negocioId) {
  const { count } = await supabase
    .from('categorias').select('id', { count: 'exact', head: true }).eq('negocio_id', negocioId);
  if (count > 0) return;
  await supabase.from('categorias').insert(CATEGORIAS_DISTRIBUIDOR.map((c, i) => ({
    negocio_id: negocioId, nombre: c.nombre, prefijo_codigo: c.prefijo, icono: c.icono,
    color: '#9CA3AF', color_fondo: '#F3F4F6', orden: i + 1,
  })));
}
